<app-dialog-heading [heading]="'Discharge'"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="formGroup">
    <mat-radio-group [attr.class]="'discharge-step'"
                     [name]="radioGroupName.DischargeRadioGroup"
                     [formControlName]="controls.DischargeType" class="m-l-5">
      <mat-radio-button [value]="dischargeType.TransferToSubAcute">{{dischargeType.TransferToSubAcute}}
      </mat-radio-button>
      <mat-radio-button [value]="dischargeType.ContinuanceOfCare">{{dischargeType.ContinuanceOfCare}}
      </mat-radio-button>
      <mat-radio-button [value]="dischargeType.PrivateHomeNursing">{{dischargeType.PrivateHomeNursing}}
      </mat-radio-button>
      <mat-radio-button [value]="dischargeType.FinalDischarge">{{dischargeType.FinalDischarge}}
      </mat-radio-button>
    </mat-radio-group>
  </form>
  <mat-dialog-actions align="center" class="dialog-button-container">
    <!-- Note:
          Case Final Discharge: -> Post Payload as Usual".
          Case OTHER than Final Discharge -> 2 Payload are sent to backend
     -->
    <button class="dialog-button" mat-raised-button color="warn" (click)="onCancelDialogClick()">Cancel</button>
    <button class="dialog-button fit-content"
            mat-raised-button color="primary" (click)="onDischargeCaseClick($event)">
      {{ selectedOption === dischargeType.FinalDischarge ? 'Finish' : 'FINISH & CREATE DISCHARGE CASE'}}
    </button>
  </mat-dialog-actions>
</div>
